var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bookmark"},[_c('v-layout',{attrs:{"row":"","align-center":""},on:{"click":_vm.handleClickBookmark}},[_c('v-icon',{attrs:{"color":"info"}},[_vm._v(_vm._s(_vm.icon))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }